import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { useEffect } from "react";

// css and images
import AccountInvoiceTabs from "../AccountInvoiceTabs";

export default function CustomerAccountInvoices() {
  const { invId } = useParams("invId");
  const { setInvoiceTarget } = useOutletContext();
  useEffect(() => {
    setInvoiceTarget("Customer");
  });
  return (
    <div className="container-fluid">
      {!invId && <AccountInvoiceTabs type="Customer" />}
      <Outlet />
    </div>
  );
}
